import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import './assets/styles.css';
import './assets/auth-styles.css';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import Auth from './pages/Auth/Auth';
import Unauthorized from './pages/Unauthorized/Unauthorized';
import Home from './pages/Home/Home';
import UploadFiles from './pages/UploadFiles/UploadFiles';
import PreviewSave from './pages/PreviewSave/PreviewSave';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import customLogger from "../src/utils/customLogger.js";

function MainApp() {
  const [processedData, setProcessedData] = useState([]);
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [additionalParamMap, setAdditionalParamMap] = useState({});
    // const [fileStatusData, setFileStatusData] = useState([])
  const [fileStatusData, setFileStatusData] = useState({
  status: '',
  data: [],
  firstName: '',
  lastName:'',
  patientId: '',
  documentType: '',
  fileName:'',
});
  // Debug function to help troubleshoot auth issues
  useEffect(() => {
   // customLogger.log('App mounted - checking localStorage:');
   // customLogger.log('Auth token:', localStorage.getItem('auth_token'));
  //  customLogger.log('Is authenticated (based on token):', !!localStorage.getItem('auth_token'));
  }, []);

  const handlePrepareData = (data) => {
    setProcessedData(data);
  };

  const handlePrepAnother = () => {
    return <Navigate to="/upload" replace />;
  };

  const handleBackToDashboard = () => {
    window.parent.postMessage(
      { action: 'loadPage', url: 'userDashboard.do' },
      // 'https://login.zerobalancedata.com:8443' // The exact parent origin (with port if needed)
      // 'https://loginn.zerobalancedata.com:8443/'
      '*'
    ); 

    // In a real app, this would navigate to a dashboard
    // return <Navigate to="/upload" replace />;
  };

  return (
    <Routes>
      {/* Entry point that handles auth redirects */}
      <Route path="/" element={<Home />} />
      
      {/* Auth routes - accessible without authentication */}
      <Route path="/auth" element={<Auth setAdditionalParamMap={setAdditionalParamMap} />} />
      <Route path="/unauthorized" element={<Unauthorized onBackToDashboard={handleBackToDashboard} additionalParamMap={additionalParamMap} />} />
      
      {/* Protected routes - require authentication */}
      <Route element={<ProtectedRoute />}>
        <Route path="/upload" element={
          <UploadFiles 
            onPrepareData={handlePrepareData}
            setAdditionalInfo={setAdditionalInfo}
            additionalParamMap={additionalParamMap}
            setAdditionalParamMap={setAdditionalParamMap}
            setFileStatusData = {setFileStatusData}
          />}
        />

        <Route path="/preview" element={
          <PreviewSave 
            data={processedData}
            additionalInfo={additionalInfo}
            onPrepAnother={handlePrepAnother}
            onBackToDashboard={handleBackToDashboard}
            additionalParamMap={additionalParamMap}
            fileStatusData= {fileStatusData}
          />
        } />
      </Route>
      
      {/* Catch-all route redirects to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Router>
          <MainApp />
        </Router>
      </AuthProvider>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
